import React from 'react';
import { FaEnvelopeOpenText } from 'react-icons/fa';

const OTPVerification = ({
  phoneNumber,
  otp,
  setOtp,
  onResend,
  onVerify,
  isResending,
  resendTimer,
}) => {
  const handleOtpChange = (e, i) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = otp.split('');
      newOtp[i] = value;
      setOtp(newOtp.join(''));
      if (value && i < 5) document.getElementById(`otp-${i + 1}`)?.focus();
    }
  };

  const handleOtpBackspace = (e, i) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) {
      document.getElementById(`otp-${i - 1}`)?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    const pasted = e.clipboardData.getData('text').trim();
    if (/^\d{6}$/.test(pasted)) {
      setOtp(pasted);
      pasted.split('').forEach((char, index) => {
        const input = document.getElementById(`otp-${index}`);
        if (input) input.value = char;
      });
      document.getElementById('otp-5')?.focus();
    }
  };

  return (
    <div className="text-center">
      <div className="h-20 w-20 mx-auto mb-6 secondary-background rounded-full flex items-center justify-center">
        <FaEnvelopeOpenText className="text-4xl text-primary" />
      </div>
      <h2 className="text-base font-semibold text-primary mb-2">OTP Verification</h2>
      <p className="text-sm  mb-6">
        Enter the OTP sent to <span className="font-medium">+91 {phoneNumber}</span>
      </p>

      <div className="flex justify-center gap-2 sm:gap-3 mb-6" onPaste={handleOtpPaste}>
        {[...Array(6)].map((_, i) => (
          <input
            key={i}
            id={`otp-${i}`}
            type="text"
            maxLength="1"
            className="w-10 h-10 sm:w-10 sm:h-10 text-center tertiary-background border border-gray-300 rounded-lg text-lg focus:outline-none focus:ring-2 border-color"
            value={otp[i] || ''}
            onChange={(e) => handleOtpChange(e, i)}
            onKeyDown={(e) => handleOtpBackspace(e, i)}
          />
        ))}
      </div>

      <p className="text-sm text-gray-600 mb-3">
        Didn’t receive the OTP?{' '}
        <button
          type="button"
          onClick={onResend}
          className="text-primary font-medium hover:underline"
          disabled={isResending || resendTimer > 0}
        >
          {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
        </button>
      </p>

      <button
        type="button"
        onClick={onVerify}
        disabled={otp.length !== 6}
        className="w-[50%] primary-background text-white py-1.5 rounded-lg transition disabled:opacity-50"
      >
        Verify OTP
      </button>
    </div>
  );
};

export default OTPVerification;
